import AssignmentIcon from '@material-ui/icons/Assignment';
import { HomeEmptyState } from '../atoms/HomeEmptyState';
import { HomeWorkItem } from '../molecules/HomeWorkItem';
import { HomeWorkQueue } from './HomeWorkQueue';
import { useHomeTickets } from '../../hooks/useHomeTickets';
import { formatHomeDate, isTicketInProgress } from '../../homeUtils';

interface HomeAssignedTicketsProps {
  backendUrl: string;
  email?: string;
}

export const HomeAssignedTickets = ({
  backendUrl,
  email,
}: HomeAssignedTicketsProps) => {
  const { tickets, loading, error, refresh } = useHomeTickets(
    backendUrl,
    email,
  );

  return (
    <HomeWorkQueue
      title="Tickets Asignados"
      count={!!tickets.length ? tickets.length : undefined}
      icon={<AssignmentIcon />}
      href="/assigned-tickets"
      onRefresh={refresh}
      refreshLabel="Actualizar tickets"
      loading={loading}
      loadingLabel="Cargando tickets"
      error={error}
      hasItems={tickets.length > 0}
      empty={
        <HomeEmptyState>No se encontraron tickets asignados.</HomeEmptyState>
      }
    >
      {tickets.map(ticket => (
        <HomeWorkItem
          key={ticket.id}
          href={`${
            ticket._jiraInstance?.baseUrl ??
            'https://digitalfemsa.atlassian.net'
          }/browse/${ticket.key}`}
          title={`${ticket.key}: ${ticket.fields.summary}`}
          status={ticket.fields.status.name}
          active={isTicketInProgress(ticket.fields.status.name)}
          metadata={`Actualizado ${formatHomeDate(ticket.fields.updated)}${
            ticket.fields.priority ? ` - ${ticket.fields.priority.name}` : ''
          }`}
        />
      ))}
    </HomeWorkQueue>
  );
};
